module.exports = __webpack_public_path__ + "img/logo.a1902039.png";